import {
  isStoryblokRichTextPresent,
  renderStoryblokRichText,
} from '@utils/renderStoryblokRichText';

import { useUnitOfMeasurement } from '../../../hooks/useUnitOfMeasurement';
import { ProductDimensionsStoryblok } from '../../../types/generated-storyblok';
import { getActiveDimensionsFormat } from './getActiveDimensionsLabel';

const Dimensions = ({
  dimensions,
  isFramed = false,
}: {
  dimensions: ProductDimensionsStoryblok;
  isFramed?: boolean;
}) => {
  const [unitMeasurement] = useUnitOfMeasurement();
  const activeDims = getActiveDimensionsFormat(
    dimensions,
    unitMeasurement,
    isFramed,
  );

  if (!activeDims) return null;

  return (
    <div className="flex flex-col">
      {(isStoryblokRichTextPresent(activeDims.displayStringAlt) &&
        renderStoryblokRichText(activeDims.displayStringAlt)) ||
        (activeDims.displayString ? <p>{activeDims.displayString}</p> : null)}
    </div>
  );
};

export default Dimensions;
